<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'layouts-home',
	};
</script>



// WEBPACK FOOTER //
// src/layouts/layouts-home.vue